// LLM generated - Model gpt-5.2-codex
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  dialogContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
  },

  container: {
    width: 440,
    position: 'relative',

    [theme.fn.smallerThan('sm')]: {
      width: '100vw',
      maxWidth: '100vw',
    },
  },
  dialogBody: {
    [theme.fn.smallerThan('sm')]: {
      padding: `${theme.other.spacing._16}px 0`,
    },
  },

  confetti: {
    zIndex: '0 !important' as unknown as number,
  },

  closeButton: {
    position: 'absolute',
    top: theme.other.spacing._16,
    right: theme.other.spacing._16,
    width: theme.other.spacing._32,
    height: theme.other.spacing._32,
    borderRadius: theme.other.spacing._24,
    backgroundColor: theme.colors.gray2[0],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    cursor: 'pointer',
    zIndex: 10,
    padding: 0,

    '&:hover': {
      backgroundColor: theme.colors.gray2[1],
    },
  },

  closeIcon: {
    width: theme.other.spacing._16, // Design-specific size, not available in theme spacing
    height: theme.other.spacing._16, // Design-specific size, not available in theme spacing
    color: theme.colors.gray2[4],
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  headerSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._16,
    width: '100%',
  },

  iconContainer: {
    width: 56, // Design-specific size, not available in theme spacing
    height: 56, // Design-specific size, not available in theme spacing
    borderRadius: theme.other.spacing._40,
    backgroundColor: theme.colors.gray2[0],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  textContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    textAlign: 'center',
    width: '100%',
    padding: `0 ${theme.other.spacing._16}px`,
  },

  heading: {
    color: theme.colors.gray2[6],
    letterSpacing: '-0.72px',
  },

  description: {
    color: theme.colors.gray2[4],
  },

  // Carousel styles
  ticketContainer: {
    width: 'calc(100% + 48px)',
    maxWidth: '100vw',
  },
  viewport: {
    paddingTop: theme.other.spacing._32,
    paddingBottom: theme.other.spacing._40,
  },
  carouselContainer: {
    justifyContent: 'stretch',
  },

  countdownContainer: {
    marginBottom: theme.other.spacing._16,
  },
  actionSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    width: '100%',
    padding: `0 ${theme.other.spacing._24}px`,
  },

  error: {
    color: theme.colors.red[3],
    textAlign: 'left',
  },
}));
